@if (loading) {
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p>{{ 'manageEvent.services.loading' | translate }}</p>
  </div>
} @else if (eventServices) {
  <div class="card card-flush mb-9">
    <div class="card-header mt-5">
      <div class="card-title flex-column">
        <h3 class="fw-bold mb-1">{{ 'manageEvent.services.title' | translate }}</h3>
        <div class="fs-6 text-gray-500">{{ 'manageEvent.services.totalServices' | translate }} {{ eventServices.length }}</div>
      </div>
      <div class="card-toolbar my-1">
        <app-button
          [variant]="'primary'"
          [label]="'manageEvent.services.addService' | translate"
          [iconClass]="'fa fa-plus'"
          [size]="'md'"
          class="ms-2"
          (clicked)="openAddEventServiceModal()"
        />
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="table-responsive">
        <table id="kt_profile_overview_table" class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold">
          <thead class="fs-7 text-gray-500 text-uppercase">
          <tr>
            <th class="min-w-250px">{{ 'manageEvent.services.name' | translate }}</th>
            <th class="min-w-90px">{{ 'manageEvent.services.description' | translate }}</th>
            <th class="min-w-90px">{{ 'manageEvent.services.registrations' | translate }}</th>
            <th class="min-w-50px ">{{ 'manageEvent.services.price' | translate }}</th>
            <th class="min-w-50px ">{{ 'manageEvent.services.total' | translate }}</th>
            <th class="text-end min-w-70px">{{ 'manageEvent.services.actions' | translate }}</th>
          </tr>
          </thead>
          <tbody class="fs-6">
            @for (service of eventServices; track service.event_service_id) {
              <tr class="cursor-pointer" (click)="openViewRegistrationsModal(service)">
                <td>
                  <div class="d-flex align-items-center">
                    <div class="d-flex flex-column justify-content-center">
                      <span class="fs-6 text-gray-800">{{ service.event_service_name }}</span>
                    </div>
                  </div>
                </td>
                <td>{{ service.event_service_description}}</td>
                <td>{{ getTotalRegistrations(service) }} / {{ service.max_num_registrations }}</td>
                <td>{{ service.price || 0 }} {{service.price_currency}}</td>
                <td>{{ getServiceNetRevenue(service) | number:'1.2-2' }} {{service.price_currency}}</td>
                <td class="text-end" (click)="$event.stopPropagation()">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="openViewRegistrationsModal(service)">
                          <i class="far fa-eye me-2"></i>
                          {{ 'manageEvent.services.viewRegistrations' | translate }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="openEditEventServiceModal(service)">
                          <i class="far fa-edit me-2"></i>
                          {{ 'manageEvent.services.editService' | translate }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="openMembershipPricingModal(service)">
                          <i class="fas fa-tag me-2"></i>
                          {{ 'manageEvent.services.membershipPricing' | translate }}
                        </a>
                      </li>
                      <li><hr class="dropdown-divider"></li>
                      <li>
                        <a class="dropdown-item text-danger" (click)="deleteEventService(service)">
                          <i class="far fa-trash-can me-2"></i>
                          {{ 'manageEvent.services.deleteService' | translate }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
